import React from "react";
import { trb, i18 } from "@utilities";
import { TableElement } from "./TableElement";
import moment from "moment";

export const Title = () => (
  <div className="mb-3">
    <div className="row mx-0">
      <div className="col-4">
        <div className="d-flex align-items-start flex-column h-100">
          <div className="mt-auto w-100">
            <div className="row pt-3 no-page-break mx-0">
              <div className="col-10">
                {TableElement(
                  [
                    [
                      {
                        type: "input",
                        title: trb(i18.Labels.Date),
                        value: moment(new Date()).format("YYYY-MM-DD"),
                        width: "80%"
                      }
                    ]
                  ],
                  "",
                  "",
                  "mb-0 w-100"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-8 right">{trb(i18.PrintLabels.PdfTitleInfoMessage)}</div>
      <div className="col-12 mt-3 d-flex justify-content-center">
        <h1>
          <b>{trb(i18.PrintLabels.Questionnaire)}</b>
        </h1>
      </div>
    </div>
  </div>
);
